/* Elanessa: ws-timeline behaviour. Moved out of the section's inline <script> on 2026-09-03 so it
   loads deferred and cached instead of running mid-parse. One init per root element;
   re-runs for sections added in the theme editor. */
(function () {
  function init(root) {
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';

    var steps = Array.prototype.slice.call(root.querySelectorAll('.wsb-step'));
    var track = root.querySelector('[data-wsb-track]');
    var bar = root.querySelector('[data-wsb-progress]');
    if (!steps.length) return;

    // The dot is .wsb-step::before — 7px tall at top:8px — so its centre
    // sits 11.5px below the step's top edge. Span the rail first dot to last.
    var DOT_CENTRE = 11.5;

    function sizeTrack() {
      if (!track || steps.length < 2) return;
      var first = steps[0].offsetTop + DOT_CENTRE;
      var last = steps[steps.length - 1].offsetTop + DOT_CENTRE;
      track.style.top = first + 'px';
      track.style.height = Math.max(0, last - first) + 'px';
    }

    function activateThrough(i) {
      steps.forEach(function (s, n) { if (n <= i) s.classList.add('is-active'); });
      if (bar) bar.style.height = Math.round(((i + 1) / steps.length) * 100) + '%';
    }

    sizeTrack();
    // re-measure once images have laid out, and on resize
    window.addEventListener('load', sizeTrack);
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(sizeTrack, 150);
    });
    if ('ResizeObserver' in window) {
      new ResizeObserver(sizeTrack).observe(root);
    }

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      activateThrough(steps.length - 1);
      return;
    }

    var seen = -1;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var i = steps.indexOf(e.target);
        if (i > seen) { seen = i; activateThrough(i); }
      });
    }, { threshold: 0.5, rootMargin: '0px 0px -15% 0px' });

    steps.forEach(function (s) { io.observe(s); });
  }
  function initAll(scope) {
    (scope || document).querySelectorAll('[data-elanessa-init="timeline"]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
